import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Input,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Checkbox,
  Text,
  IconButton,
  Stack,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";
import { Link as RouterLink } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";
import axios from "axios";
import * as mod from "../../url"; // Update with your actual URL file path
const token = JSON.parse(sessionStorage.getItem("superAdminLawvs"))?.data
  ?.token;
const config = { headers: { Authorization: token } };
const SIDEBAR_WIDTH = "250px";
const RECORDS_PER_PAGE = 20;

const DraftPaid = () => {
  const [allDrafts, setAllDrafts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [drafts, setDrafts] = useState([]);
  const toast = useToast();

  // Fetch drafts from API
  const fetchAllDrafts = async () => {
    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/draft/get-Allorder-byAdmin`,
      );
      //   console.log(data, "ijoijdsps");
      setAllDrafts(data?.orders);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching drafts:", error);
      setLoading(false);
    }
  };

  const handleStatusToggle = async (slug, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    try {
      await axios.put(
        `${mod.api_url}/api/v1/draft/update-status/${slug}`,
        { status: newStatus },
        config,
      );

      setAllDrafts((prevDrafts) =>
        prevDrafts.map((draft) =>
          draft.slug === slug ? { ...draft, status: newStatus } : draft,
        ),
      );
    } catch (error) {
      console.error("Failed to update status", error);
    }
  };

  useEffect(() => {
    fetchAllDrafts();
  }, []);
  const handleDelete = async (slug) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this draft?",
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `${mod.api_url}/api/v1/draft/delete_drafts/${slug}`,
        config,
      );

      // Update state to remove the deleted draft
      setAllDrafts((prevDrafts) =>
        prevDrafts.filter((draft) => draft.slug !== slug),
      );

      toast({
        title: "Draft deleted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Delete error:", error);
      toast({
        title: "Failed to delete draft.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Pagination calculation
  const totalPages = Math.ceil(allDrafts?.length / RECORDS_PER_PAGE);
  const startIdx = (currentPage - 1) * RECORDS_PER_PAGE;
  const currentRecords = allDrafts.slice(startIdx, startIdx + RECORDS_PER_PAGE);

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="100px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={6}>
        <Text fontSize="2xl" mb={4} size="md" bg="#D29B3F" p={3}>
          <strong>Paid Drafts</strong>
        </Text>

        <Flex
          bg="white"
          p={4}
          mb={4}
          borderRadius="md"
          boxShadow="sm"
          align="center"
          flexWrap="wrap"
          gap={4}
        >
          <Input
            placeholder="Enter title, name or keyword to search record"
            maxW="300px"
          />

          <Flex ml="auto">
            <Button
              colorScheme="blue"
              leftIcon={<AddIcon />}
              as={RouterLink}
              to="/Create-legal-draft"
              _hover={{ bg: "blue.100" }}
              textDecoration="none"
            >
              Add New Record
            </Button>
          </Flex>
        </Flex>

        <Box bg="white" p={4} borderRadius="md" boxShadow="sm">
          <Text fontSize="sm" mb={1} textAlign={"right"} align={"right"}>
            Total Record: {allDrafts?.length}
          </Text>
          {/* <Text fontSize="sm"></Text> */}
          {loading ? (
            <Spinner size="xl" />
          ) : (
            <>
              <Table
                variant="simple"
                size="sm"
                style={{ border: "1px solid #ccc", borderCollapse: "collapse" }}
              >
                <Thead bg="gray.100">
                  <Tr>
                    {/* <Th border="1px solid #ccc">
                      <Checkbox />
                    </Th> */}
                    <Th border="1px solid #ccc">Sr. No</Th>
                    {/* <Th border="1px solid #ccc">ID</Th> */}
                    <Th border="1px solid #ccc">Title</Th>
                    {/* <Th border="1px solid #ccc">Description</Th> */}
                    <Th border="1px solid #ccc">Date</Th>
                    <Th border="1px solid #ccc">User</Th>
                    {/* <Th border="1px solid #ccc">Status</Th> */}
                    {/* <Th border="1px solid #ccc">Delete</Th> */}
                  </Tr>
                </Thead>
                <Tbody>
                  {currentRecords?.map((draft, index) => (
                    <Tr key={draft?._id}>
                      {/* <Td border="1px solid #ccc">
                        <Checkbox />
                      </Td> */}
                      <Td border="1px solid #ccc">{startIdx + index + 1}</Td>
                      <Td border="1px solid #ccc">
                        <ChakraLink
                          as={RouterLink}
                          to={`/single-draft/${draft?.draft.slug}`} // navigate to single draft page
                          color="blue.500"
                          _hover={{ textDecoration: "underline" }}
                        >
                          {draft?.draft?.title?.slice(0, 100)}
                        </ChakraLink>
                      </Td>

                      <Td border="1px solid #ccc">
                        {new Date(draft.createdAt).toLocaleDateString()}
                      </Td>
                      <Td border="1px solid #ccc">
                        <ChakraLink
                          as={RouterLink}
                          //   to={`/update-draft/${draft?.draft?.slug}`}
                          color="blue.500"
                          _hover={{ textDecoration: "underline" }}
                        >
                          {draft?.user?.email}
                        </ChakraLink>
                      </Td>
                      {/* <Td border="1px solid #ccc">
                        <Button
                          size="sm"
                          colorScheme={
                            draft?.status === "active" ? "green" : "red"
                          }
                          onClick={() =>
                            handleStatusToggle(draft?.slug, draft?.status)
                          }
                        >
                          {draft?.status === "active" ? "Active" : "Inactive"}
                        </Button>
                      </Td> */}

                      {/* <Td border="1px solid #ccc">
                        <IconButton
                          icon={<DeleteIcon />}
                          colorScheme="red"
                          size="sm"
                          aria-label="Delete"
                          onClick={() => handleDelete(draft.slug)}
                        />
                      </Td> */}
                    </Tr>
                  ))}
                </Tbody>
              </Table>

              {/* Pagination */}
              <Flex justify="space-between" align="center" mt={4}>
                <Stack direction="row" spacing={2}>
                  {Array.from({ length: totalPages }).map((_, idx) => (
                    <Button
                      key={idx}
                      size="sm"
                      onClick={() => setCurrentPage(idx + 1)}
                      colorScheme={currentPage === idx + 1 ? "blue" : "gray"}
                      variant={currentPage === idx + 1 ? "solid" : "outline"}
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </Stack>
              </Flex>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default DraftPaid;
